import classes from './SelectableCardBody.module.scss'

interface Props {
  children: React.ReactNode
}

export function SelectableCardBody({ children }: Readonly<Props>) {
  return <div className={classes.SelectableCardBody}>{children}</div>
}
